import React, { Component } from 'react';
import { Link, withRouter } from "react-router-dom";
import classNames from 'classnames';
import routes from '../../routes';
// import './SideNav.scss';
import logo from '../../assets/images/Sidenav_logo.png';
import { checkPermission } from '../../utils/route-auth';
import { MODULE_PERMISSIONS } from '../../constants/permission';
import { connect } from "react-redux";
import { get } from 'lodash';
import { message } from "antd";
import { checkFeeManagementAccess, isTenantAdvertiser } from '../../selectors';
import { clearAllReduxDataDashoardScreen1, clearAllReduxDataDashoardScreen2 } from '../../actions';



class SideNav extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isSidebarCollapsed: false,
        };
    }

    handleLogoClick = () => {
        const { history, match, preSignInResponseList } = this.props;
        history.push(`${match.path}/${routes.home}`);
        // if (preSignInResponseList[0].tenantType == "Platform Manager") {
        //     message.error("Home :: Access Denied for Platform Manager")
        // }
        // else {
        //     history.push(`${match.path}/${routes.home}`);
        // }
    }

    collapseToggle = (e) => {
        e.preventDefault();
        const { toggleSidebar, isCollapse } = this.props;
        window.Helpers.toggleCollapsed();
        toggleSidebar(isCollapse);
    }

    clearDashBoardDataRedux = async () => {
        const { clearAllReduxDataDashoardScreen2, clearAllReduxDataDashoardScreen1 } = this.props;
        clearAllReduxDataDashoardScreen1();
        clearAllReduxDataDashoardScreen2();
    }


    render() {
        const { match, location, daysDifference, hoursDifference, minutesDifference, secondsDifference,
            dashboardAcessDetails, campaignAcessDetails, optimizerAcessDetails, walletAcessDetails, mediaPlanAcessDetails, tenantId } = this.props;
        const { pathname } = location;
        const currentPath = pathname.split('/');

        // const {countUnmapped = 0} = this.props

        return (
            <aside id="layout-menu" className="layout-menu menu-vertical menu bg-menu-theme position-fixed shadow-none" data-bg-class="bg-menu-theme"
                style={{ touchAction: 'none', userSelect: 'none', WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)', minHeight: '100vh' }}
            >
                <div class="app-brand demo">
                    <a href="javascript:void(0);" onClick={this.handleLogoClick} class="app-brand-link">
                        <img src={logo} style={{ maxWidth: 150 }} width="60%" />
                    </a>

                    <a href="javascript:void(0);" onClick={(e) => this.collapseToggle(e)} class="layout-menu-toggle menu-link text-large ms-auto text-decoration-none">
                        <i class="ti menu-toggle-icon d-none d-xl-block ti-sm align-middle"></i>
                        <i class="ti ti-x d-block d-xl-none ti-sm align-middle"></i>
                    </a>
                    {
                        this.props.isCollapse &&
                        <a href="javascript:void(0);" onClick={(e) => this.collapseToggle(e)} class="player text-large ms-auto text-decoration-none" >
                            <i class="ti ti-player-record ti-sm" style={{ color: '#6f6b7d' }}></i>
                        </a>
                    }

                </div>

                <div class="menu-inner-shadow" style={{ display: 'none' }}></div>

                <ul class="menu-inner py-1 ps ps--active-y">
                    {
                        checkPermission({ permissions: MODULE_PERMISSIONS.DASHBOARD }) && (
                            // (daysDifference > 0) || (hoursDifference > 0) || (minutesDifference > 0) || (secondsDifference > 0) ?
                            <div onClick={() => { this.clearDashBoardDataRedux() }} className={classNames('menu-item', { 'active': currentPath.includes(routes.containers.dashboard) })} >
                                <Link to={`${match.path}/${routes.containers.dashboard}`} className="menu-link text-decoration-none">
                                    <i class="menu-icon ti ti-chart-bar ti-md"></i>
                                    <div data-i18n="Dashboard">Dashboard</div>
                                </Link>
                            </div>
                            //  : ''

                        )
                    }

                    {
                        checkPermission({ permissions: MODULE_PERMISSIONS.ADMIN }) && (
                            <div className={classNames('menu-item', { 'active': currentPath.includes(routes.containers.admin) })} >
                                <Link to={`${match.path}/${routes.containers.admin}`} className="menu-link text-decoration-none">
                                    <i class="menu-icon tf-icons ti ti-user-circle"></i>
                                    <div data-i18n="Admin">Admin</div>
                                </Link>
                            </div>
                        )
                    }

                    {/* {
                        checkPermission({ permissions: MODULE_PERMISSIONS.MEDIAPLAN }) && (
                            // (daysDifference > 0) || (hoursDifference > 0) || (minutesDifference > 0) || (secondsDifference > 0) ?
                            <div className={classNames('menu-item', { 'active': currentPath.includes(routes.containers.mediaPlan) })} >
                                <Link to={`${match.path}/${routes.containers.mediaPlan}`} className="menu-link text-decoration-none">
                                    <i class="menu-icon tf-icons ti ti-businessplan"></i>
                                    <div data-i18n="Media Plan">Media Plan</div>
                                </Link>
                            </div>
                            //  : ''

                        )
                    } */}

                    {/* {
                        checkPermission({ permissions: MODULE_PERMISSIONS.IO }) && (
                            <div className={classNames('menu-item', { 'active': currentPath.includes(routes.containers.advertiser) })} >
                                <Link to={`${match.path}/${routes.containers.advertiser}`} className="menu-link">
                                    <i class="menu-icon tf-icons ti ti-businessplan"></i>
                                    <div data-i18n="Advertiser">Advertiser</div>
                                </Link>
                            </div>
                        )
                    } */}

                    {
                        checkPermission({ permissions: MODULE_PERMISSIONS.CAMPAIGN }) && (
                            // (daysDifference > 0) || (hoursDifference > 0) || (minutesDifference > 0) || (secondsDifference > 0) ?
                            <div className={classNames('menu-item', { 'active': currentPath.includes(routes.containers.campaignList) })} >
                                <Link to={`${match.path}/${routes.containers.campaignList}`} className="menu-link text-decoration-none">
                                    <i class="menu-icon tf-icons ti ti-speakerphone"></i>
                                    <div data-i18n="Campaign">Campaign</div>
                                </Link>
                            </div>
                            //  : ''

                        )
                    }

                    {
                        checkPermission({ permissions: MODULE_PERMISSIONS.CREATIVE }) && (
                            // (daysDifference > 0) || (hoursDifference > 0) || (minutesDifference > 0) || (secondsDifference > 0) ?
                            <div className={classNames('menu-item', { 'active': currentPath.includes(routes.containers.creative) })} >
                                <Link to={`${match.path}/${routes.containers.creative}`} className="menu-link text-decoration-none">
                                    <i class="menu-icon tf-icons ti ti-photo"></i>
                                    <div data-i18n="Campaign">Creative</div>
                                </Link>
                            </div>
                            //  : ''
                        )
                    }

                    {/* {

                    {
                        checkPermission({ permissions: MODULE_PERMISSIONS.ADMINMARGIN }) && (
                            <div className={classNames('menu-item', { 'active': currentPath.includes(routes.containers.adminMargin) })} >
                                <Link to={`${match.path}/${routes.containers.adminMargin}`} className="menu-link text-decoration-none">
                                    <i class="menu-icon tf-icons ti ti-chart-area-line"></i>
                                    <div data-i18n="Admin Margin">Admin Margin</div>
                                </Link>
                            </div>
                        )
                    } */}

                    {/* {
                        checkPermission({ permissions: MODULE_PERMISSIONS.MARGIN }) && (
                            <div className={classNames('menu-item', { 'active': currentPath.includes(routes.containers.margin) })} >
                                <Link to={`${match.path}/${routes.containers.margin}`} className="menu-link text-decoration-none">
                                    <i class="menu-icon tf-icons ti ti-chart-line"></i>
                                    <div data-i18n="Margin">Margin</div>
                                </Link>
                            </div>

                        )
                    } */}

                    {/* {
                        (checkPermission({ permissions: MODULE_PERMISSIONS.RO }) || checkPermission({ permissions: MODULE_PERMISSIONS.UNMAPPEDCAMPAIGN })) && (
                            <div style={{ position: 'relative' }} className={classNames('menu-item', { 'active': currentPath.includes(routes.containers.goals) })} >
                                <Link to={`${match.path}/${routes.containers.goals}`} className="menu-link text-decoration-none">
                                    <i class="menu-icon tf-icons ti ti-code"></i>
                                    <div data-i18n="Margin">Goals</div>
                                </Link>
                              

                            </div>

                        )
                    } */}


                    {/* {
                        checkPermission({ permissions: MODULE_PERMISSIONS.RO }) && (
                            <div className={classNames('menu-item', { 'active': currentPath.includes(routes.containers.ro) })} >
                                <Link to={`${match.path}/${routes.containers.ro}`} className="menu-link text-decoration-none">
                                    <i class="menu-icon tf-icons ti ti-code"></i>
                                    <div data-i18n="Margin">RO</div>
                                </Link>
                            </div>

                        )
                    } */}

                    {/* {
                        checkPermission({ permissions: MODULE_PERMISSIONS.UNMAPPEDCAMPAIGN }) && (
                            <div className={classNames('menu-item', { 'active': currentPath.includes(routes.containers.unmappedCampaign) })} >
                                <Link to={`${match.path}/${routes.containers.unmappedCampaign}`} className="menu-link text-decoration-none">
                                    <i class="menu-icon tf-icons ti ti-alert-triangle"></i>
                                    <div data-i18n="Margin">Unmapped Campaign</div>
                                </Link>
                            </div>

                        )
                    } */}

                    {
                        checkPermission({ permissions: MODULE_PERMISSIONS.AUDIENCE }) && (
                            <div className={classNames('menu-item', { 'active': currentPath.includes(routes.containers.audience) })} >
                                <Link to={`${match.path}/${routes.containers.audience}`} className="menu-link text-decoration-none">
                                    <i class="menu-icon tf-icons ti ti-users"></i>
                                    <div data-i18n="Margin">Audience</div>
                                </Link>
                            </div>
                        )
                    }

                    {
                        checkPermission({ permissions: MODULE_PERMISSIONS.OPTIMIZER }) && (
                            // (daysDifference > 0) || (hoursDifference > 0) || (minutesDifference > 0) || (secondsDifference > 0) ?
                            <div className={classNames('menu-item', { 'active': currentPath.includes(routes.containers.optimizer) })} >
                                <Link to={`${match.path}/${routes.containers.optimizer}`} className="menu-link text-decoration-none">
                                    <i class="menu-icon tf-icons ti ti-chart-infographic"></i>
                                    <div data-i18n="Margin">Optimizer</div>
                                </Link>
                            </div>
                            //  : ''

                        )
                    }

                    {/* {
                        checkPermission({ permissions: MODULE_PERMISSIONS.DATACONFIG }) &&
                        (<div className={classNames('menu-item', { 'active': currentPath.includes(routes.containers.dataConfig) })} >
                            <Link to={`${match.path}/${routes.containers.dataConfig}`} className="menu-link text-decoration-none">
                                <i class="menu-icon mdi mdi-database"></i>
                                <div data-i18n="Margin">Data Config</div>
                            </Link>
                        </div>)
                    } */}

                    {/* {
                        checkPermission({ permissions: MODULE_PERMISSIONS.PAYMENT }) && (daysDifference > 0 ) || (hoursDifference > 0 ) || (minutesDifference > 0 ) ||(secondsDifference > 0 ) ? (
                        <div className={classNames('menu-item', { 'active': currentPath.includes(routes.containers.payment) })} >
                            <Link to={`${match.path}/${routes.containers.payment}`} className="menu-link text-decoration-none">
                                <i class="menu-icon mdi mdi-wallet"></i>
                                <div data-i18n="Margin">Billing</div>
                            </Link>
                        </div>

                        ) : ''
                    }  */}


                    {
                        checkPermission({ permissions: MODULE_PERMISSIONS.PAYMENT }) && (
                            // (daysDifference > 0) || (hoursDifference > 0) || (minutesDifference > 0) || (secondsDifference > 0) ?
                            <div className={classNames('menu-item', { 'active': currentPath.includes(routes.containers.payment) })} >
                                <Link to={`${match.path}/${routes.containers.payment}`} className="menu-link text-decoration-none">
                                    <i class="menu-icon ti ti-coin ti-md"></i>
                                    <div data-i18n="Margin">Billing</div>
                                </Link>
                            </div>
                            //  : ''
                        )
                    }

                    {
                        isTenantAdvertiser(tenantId) ?
                            null
                            :
                            checkPermission({ permissions: MODULE_PERMISSIONS.FEESETTING }) && checkFeeManagementAccess() && (
                                // (daysDifference > 0) || (hoursDifference > 0) || (minutesDifference > 0) || (secondsDifference > 0) ?
                                <div className={classNames('menu-item', { 'active': currentPath.includes(routes.containers.feeSettings) })} >
                                    <Link to={`${match.path}/${routes.containers.feeSettings}`} className="menu-link text-decoration-none">
                                        <i class="menu-icon ti ti-adjustments-alt"></i>
                                        <div data-i18n="Margin">Fee Setting</div>
                                    </Link>
                                </div>
                                //  : ''
                            )
                    }

                </ul>
            </aside>
        );
    }
}


export default withRouter(connect(
    (state) => ({
        countUnmapped: get(state, "app.countUnmapped.response.count"),
        preSignInResponseList: get(state, 'app.preSignInData.responseList', []),
        tenantId: get(state, 'app.preSignInState.tenantId', '')
    }), {
    clearAllReduxDataDashoardScreen1,
    clearAllReduxDataDashoardScreen2
}
)(SideNav));